/**
 * components/cardeditor/Toolbar.jsx — editor toolbar.
 *
 * Chunk 3 + post-ship fix (Apr 24 2026):
 *   - Added Backdrop switcher (Minimal wave vs Premium mountain/banner).
 */

export function Toolbar({ editor, saving, onSave, onReset, onClose, canReset }) {
  const { layout, canUndo, canRedo, undo, redo, dirty, changeBackdrop } = editor;

  const currentBackdrop = layout?.basedOnTemplate || 'minimal';

  return (
    <div
      className="card-editor-toolbar"
      style={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        padding: 'var(--sp-3) var(--sp-4)',
        borderBottom: '1px solid var(--line-soft)',
        gap: 'var(--sp-3)',
        flexWrap: 'wrap',
      }}
    >
      <div style={{ display: 'flex', gap: 'var(--sp-2)', alignItems: 'center' }}>
        <button
          type="button"
          className="btn btn-ghost"
          onClick={undo}
          disabled={!canUndo}
          title="Undo (Cmd/Ctrl+Z)"
          style={{ fontSize: 'var(--fs-sm)' }}
        >
          Undo
        </button>
        <button
          type="button"
          className="btn btn-ghost"
          onClick={redo}
          disabled={!canRedo}
          title="Redo (Cmd/Ctrl+Shift+Z)"
          style={{ fontSize: 'var(--fs-sm)' }}
        >
          Redo
        </button>

        {/* Backdrop switcher */}
        <label
          style={{
            display: 'flex',
            alignItems: 'center',
            gap: 'var(--sp-2)',
            fontSize: 'var(--fs-sm)',
            marginLeft: 'var(--sp-3)',
          }}
          title="Switch between Minimal (wave band) and Premium (mountains or uploaded banner). Element positions are preserved — you may need to reposition anything that clashes with the new backdrop."
        >
          <span className="muted" style={{ fontSize: 'var(--fs-xs)' }}>Backdrop:</span>
          <select
            value={currentBackdrop}
            onChange={(e) => changeBackdrop(e.target.value)}
            className="field-input"
            style={{
              padding: 'var(--sp-1) var(--sp-2)',
              fontSize: 'var(--fs-sm)',
            }}
          >
            <option value="minimal">Minimal (wave)</option>
            <option value="premium">Premium (mountain / banner)</option>
          </select>
        </label>

        {canReset && (
          <button
            type="button"
            className="btn btn-ghost"
            onClick={onReset}
            title="Discard custom layout and revert to the template preset"
            style={{ fontSize: 'var(--fs-sm)', color: '#b42318' }}
          >
            Reset to preset
          </button>
        )}
      </div>

      <div style={{ display: 'flex', gap: 'var(--sp-2)', alignItems: 'center' }}>
        {dirty && (
          <span className="muted" style={{ fontSize: 'var(--fs-xs)' }}>
            Unsaved changes
          </span>
        )}
        <button
          type="button"
          className="btn btn-ghost"
          onClick={onClose}
          style={{ fontSize: 'var(--fs-sm)' }}
        >
          Close
        </button>
        <button
          type="button"
          className="btn btn-primary"
          onClick={onSave}
          disabled={saving || !dirty}
          aria-busy={saving}
          style={{ fontSize: 'var(--fs-sm)' }}
        >
          {saving ? 'Saving…' : 'Save layout'}
        </button>
      </div>
    </div>
  );
}
